import { EventBus } from '@fiverr-private/futile';

export const bus = new EventBus();
export const PAUSE_PLAYERS = 'pausePlayers';
export const MUTE_PLAYERS = 'mutePlayers';
export const UNMUTE_PLAYERS = 'unmutePlayers';
export const PAUSE_INTERNAL_PLAYERS = 'pauseInternalPlayers';
